module.exports = __webpack_public_path__ + "img/61.08f6f4a7.jpg";